import { useNavigate } from 'react-router-dom';
import { Button, Card, EmptyState } from '../../components/ui';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <Card>
      <EmptyState
        icon="search"
        title="This page doesn't exist"
        message="The link may be old or typed wrong."
        action={<Button onClick={() => navigate('/')}>Go to home</Button>}
      />
    </Card>
  );
}
